<template>
  <div>
    <div class="b-banner-con">
      <v-header></v-header>
      <v-nav></v-nav>
    </div>
    <v-breadcrumb></v-breadcrumb>
    <div class="b-center-container">
      <div class="b-container">
        <div class="b-center-main">
          <div class="b-richtext">
            <p v-html="richText2"></p>
          </div>
        </div>
      </div>
    </div>
    <v-contact></v-contact>
  </div>
</template>
<script>
/* eslint-disable */
import Header from "@/components/header/en/";
import Nav from "@/components/nav/en/";
import Copy from "@/components/copy/"
import Breadcrumb from "@/components/breadcrumb/en/"
import Contact from "@/components/contact/en/";
export default {
  data () {
    return {
      richText2: '',
    };
  },
  mounted () {
    this.richText2 = '<p style="text-align: left; "><span style="font-size: 22px; border-bottom: solid 3px #033d80;">The Element Analysis Unit</span></p>'
      + '<p>&nbsp;</p>'

      + '<div id="left" style="float:left ; width:75%; height:100%;">'
      + '<p style="margin-right : 20px;text-align: justify;line-height: 250%"><span style="font-size: 16px">The Element Analysis Unit provides the qualitative and quantitative analysis of metal, metalloid and some nonmetallic elements of samples with different matrix at main, micro or trace '
      + ' level; quantitative analysis of cation and anion, organic acids and sugars; analysis of C, H, N, S and O elements in organic and inorganic substances; and element valence analysis.</span></p>'
      + '</div>'

      + '<div id="right" style="float:left ; width:25%; height:100%;">'
      + '<p style="margin-left : 40px"><img src="https://nbcloud-repairorder-image.oss-cn-beijing.aliyuncs.com/lijiang.jpg" style="float: left; width: 200px; margin-right: 30px; margin-top:20px;" border="0" vspace="0" alt=""></p>'
      + '<p style="margin-left:50px;text-align: justify"><span style="font-size: 16px;"><b>Director: Li Jiang</b></span></p>'
      + '</div>'

      + '<div>'
      + '<p><span style="font-size: 16px;border:10px solid #033d80; background-color: #033d80; border-radius: 7px; color: white;"> Qualitative and Quantitative Analysis System of Elements </span></p>'
      + '<p style="margin-top : 30px;margin-bottom : 10px; margin-right : 20px;text-align: justify"><span style="font-size: 16px">Key Equipment： ICPMS, ICP, WDXRF , WDXRF and supporting pretreatment equipments.</span></p>'
      + '<p style="margin-top : 0px;margin-bottom : 30px; margin-right : 20px;text-align: justify"><span style="font-size: 16px">Services：Element analysis in the fields of biology, medicine, materials, environment, agriculture and forestry.</span></p>'

      + '<p><span style="font-size: 16px;border:10px solid #033d80; background-color: #033d80; border-radius: 7px;color: white; "> Quantitative Analysis System of Cation and Anion</span></p>'
      + '<p style="margin-top : 30px;margin-bottom : 10px; margin-right : 20px;text-align: justify"><span style="font-size: 16px">Key Equipment：Ion Chromatograph.</span></p>'
      + '<p style="margin-top : 0px;margin-bottom : 30px; margin-right : 20px;text-align: justify"><span style="font-size: 16px">Services: Quantitative analysis of anions / some cations / small molecules of organic acids or organic amines / sugars, etc.</span></p>'

      + '<p><span style="font-size: 16px;border:10px solid #033d80; background-color: #033d80; border-radius: 7px; color: white;"> C. H, N, S, O Analysis System </span></p>'
      + '<p style="margin-top : 30px;margin-bottom : 10px; margin-right : 20px;text-align: justify"><span style="font-size: 16px">Key Equipment：Element Analyzer, High-Frequency Infrared Carbon Sulfur Meter, Organic Carbon Element Carbon Analyzer.</span></p>'
      + '<p style="margin-top : 0px;margin-bottom : 30px; margin-right : 20px;text-align: justify"><span style="font-size: 16px">Services: Quantitative analysis of C, H, N, S, and O in Organic substances; quantitative analysis of C and S \n' +
      'in inorganic substances.</span></p>'

      + '<p><span style="font-size: 16px;border:10px solid #033d80; background-color: #033d80; border-radius: 7px;color: white; "> &nbsp;&nbsp;Element Valence Analysis System&nbsp;&nbsp;</span></p>'
      + '<p style="margin-top : 30px;margin-bottom : 10px; margin-right : 20px;text-align: justify"><span style="font-size: 16px">Key Equipment：HPLC/ICPMS system and HPLC/IC system.</span></p>'
      + '<p style="margin-top : 0px;margin-bottom : 30px; margin-right : 20px;text-align: justify"><span style="font-size: 16px">Services: Analysis of the valence of arsenic（As）, selenium（Se）, mercury（Hg）, chromium （Cr）and other elements.</span></p>'

      + '<p style="text-align: center;"><img src="https://nbcloud-repairorder-image.oss-cn-beijing.aliyuncs.com/element_analysis_en_1.jpg" style="float: left; width: 800px; " border="0" vspace="0" ></p>'

      + '<p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p>'
      + '<p style="text-align: left; "><span style="font-size: 16px; border-bottom: solid 3px #033d80;">Contact</span></p>'
      + '<p style="text-align: left; "><span style="font-size: 16px; ">Li Jiang</span></p>'
      + '<p style="text-align: left; "><span style="font-size: 16px; ">Email: hi_jiangli@sjtu.edu.cn</span></p>'
      + '<p style="text-align: left; "><span style="font-size: 16px; ">Tel: +86-021-34208498-6523</span></p>'

      + '</div>'

      + '<p>&nbsp;</p><p>&nbsp;</p>'
},
  components: {
    "v-header": Header,
    "v-nav": Nav,
    "v-copy": Copy,
    "v-breadcrumb": Breadcrumb,
    "v-contact": Contact,
  }
};
</script>
<style lang="scss">
  @media screen and (max-width:600px) {
	.b-banner-con{
	    //padding: 22px 0;
	    background: url(../../../assets/img/banner_bg.png) no-repeat!important;
	    background-size: cover!important;
	    .b-header{
	      margin-bottom: 0px;
	    }
	    height: 134px;
	    width: 1440px;
	}
  }

  @media screen and (min-width:960px) {
    .b-banner-con{
	    //padding: 22px 0;
	    background: url(../../../assets/img/banner_bg.png) no-repeat!important;
	    background-size: cover!important;
	    .b-header{
	      margin-bottom: 0px;
	    }
	    height: 134px;
    }
  }
.b-richtext {
  text-align:left;
  b,
  strong {
    font-weight: 700;
  }
  p {
    margin: 0 0 10px;
    line-height: 24px;
  }
  line-height: 24px;
}
</style>



// WEBPACK FOOTER //
// src/pages/Service15/en/index.vue